import {Box, Text} from "@mantine/core";

export default function _Text({component}){

    return (
        <Box
            bg={component?.customize_styles?.general_decoration?.background_color}
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            style={{
                boxShadow: `#00000014 ${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Text
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                fz={component?.customize_styles?.text_decoration?.font_size}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
                fs={component?.customize_styles?.text_decoration?.font_style}
                ta={component?.customize_styles?.text_decoration?.text_align}
                fw={component?.customize_styles?.text_decoration?.font_weight}
                lh={component?.customize_styles?.text_decoration?.text_height}
            >
                {component?.customize_properties?.label}
            </Text>
        </Box>

    )
}